import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseApiUrls } from './ApiHelpers';

export const liveVetApi = createApi({
  reducerPath: 'liveVetApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BaseApiUrls.middlewareApiUrl
  }),
  endpoints: (builder) => ({
    generateConsultationUrl: builder.mutation({
      query: (data) => ({
        url: '/api/pet/vetChatConsultation',
        method: 'POST',
        body: data
      })
    })
  })
});

export const { useGenerateConsultationUrlMutation } = liveVetApi;
